import defaultRenderEmpty from './renderEmpty';
import zh_CN from '../../locale/zh_CN';

export const ConfigConsumerProps = {
  getPrefixCls: (suffixCls, customizePrefixCls) => {
    if (customizePrefixCls) return customizePrefixCls;
    return `ant-${suffixCls}`;
  },
  locale: zh_CN,
  renderEmpty: defaultRenderEmpty,
};
